import styled from 'styled-components';

import { colors } from '@style-guide/config';

const Wrapper = styled.div`
  align-items: center;
  background-color: ${colors.lightGray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 100%;
`;

Wrapper.displayName = 'Wrapper';

export default Wrapper;
